import {IPrepExtensionsSiteSettings} from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';
import { IResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../../../../httpClient/serverApi/requests/Request';

export interface IUpdatePrepExtensionsSiteSettingsParams {
  prepExtensionsSiteSettings: IPrepExtensionsSiteSettings;
}

export type IUpdatePrepExtensionsSiteSettingsResult = IResult & IPrepExtensionsSiteSettings;

export class UpdatePrepExtensionsSiteSettingsRequest extends Request<IUpdatePrepExtensionsSiteSettingsParams, IUpdatePrepExtensionsSiteSettingsResult> {
  constructor(params: IUpdatePrepExtensionsSiteSettingsParams) {
    super('updatePrepExtensionsSiteSettings', params);
  }
}
